import React from "react";
import { withRouter, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { Dropdown } from "reactstrap";

import { COLLAPSED_DRAWER, FIXED_DRAWER } from "constants/ActionTypes";

import { switchLanguage, toggleCollapsedNav } from "actions/Setting";
import GeneralApi from "../../app/generalApi";
const apiGeneral = new GeneralApi();

class Header extends React.Component {
  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification,
    });
  };

  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };

  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
    });
  };
  onToggleCollapsedNav = (e) => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  constructor(props) {
    super(props);
    this.state = {
      user: {},
      searchBox: false,
      searchText: "",
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      userInfo: false,
    };

    this._mapData = this._mapData.bind(this);

    //console.log(this.props);
  }

  _mapData(data) {
    const result = data;

    let aux = [];

    for (var i in result) {
      let obj = result[i];
      aux.push(obj);
    }

    return aux;
  }

  render() {
    const innerWidth = window.innerWidth;

    return (
      <div
        className="app-main-header"
        style={{ backgroundColor: apiGeneral.getBackgroundColor() }}
      >
        <div className="d-flex app-toolbar align-items-center">
          {innerWidth <= 1080 ? (
            <span
              className={`jr-menu-icon pointer d-flex`}
              onClick={this.onToggleCollapsedNav}
            >
              <span className="menu-icon" />
            </span>
          ) : (
            <div style={{ width: "100%" }}>
              <p
                style={{
                  color: "#ffffff",
                  fontSize: "x-large",
                  textAlign: "center",
                  margin: "20px",
                }}
              >
                <b>
                  <i>Suerte</i>
                </b>{" "}
                es lo que sucede cuando mil horas de{" "}
                <b>
                  <i>entrenamiento</i>
                </b>{" "}
                se cruzan con un momento de{" "}
                <b>
                  <i>oportunidad</i>
                </b>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition } =
    settings;
  return { drawerType, locale, navigationStyle, horizontalNavPosition };
};

export default withRouter(
  connect(mapStateToProps, { toggleCollapsedNav, switchLanguage })(Header)
);



// WEBPACK FOOTER //
// ./components/Header/index.js